import { Button } from "@/components/ui/button";
import {
  CompanyContactCTA,
  CompanyPageHero,
  CompanyPageShell,
  CompanyServiceRow,
  useCompanyLang
} from "@/components/site/company/CompanyShared";
import {
  companyBookingHref,
  companyCertificateHref,
  companyInquiryHref,
  directWorkEnvironmentSlugs,
  plannedWorkEnvironmentSlugs,
  workEnvironmentLanding,
  workEnvironmentSource
} from "@/data/company";
import { PageMeta } from "@/components/site/PageMeta";

const ForetagArbetsmiljo = () => {
  const { lang, copy } = useCompanyLang();
  const a = copy.arbetsmiljo;



  return (
    <CompanyPageShell breadcrumbLabel={copy.nav.arbetsmiljo}>
      <PageMeta title={a.metaTitle} description={a.metaDescription} titleMaxLength={70} />
      <CompanyPageHero label={a.label} title={a.title}>
        <p>{a.subtitle}</p>
      </CompanyPageHero>

      <section className="py-14 lg:py-16">
        <div className="container-wide">
          <span className="text-sm font-semibold uppercase tracking-wider text-primary">{a.directEyebrow}</span>
          <h2 className="mt-2 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            {a.directTitle}
          </h2>
          <div className="mt-8 space-y-4">
            {directWorkEnvironmentSlugs.map((slug) => {
              const service = workEnvironmentLanding[slug];
              return (
                <CompanyServiceRow
                  key={slug}
                  title={service.title[lang]}
                  intro={service.intro[lang]}
                  price={service.price[lang]}
                  actions={
                    <>
                      <Button asChild variant="hero" size="sm">
                        <a href={companyBookingHref(lang, slug)}>{copy.shared.bookDirect}</a>
                      </Button>
                      <Button asChild variant="ghost-outline" size="sm">
                        <a href={companyCertificateHref(slug, lang)}>{copy.shared.requirements}</a>
                      </Button>
                      <Button asChild variant="ghost-outline" size="sm">
                        <a href={companyInquiryHref(lang, slug)}>{copy.shared.planSeveral}</a>
                      </Button>
                    </>
                  }
                />
              );
            })}
          </div>
        </div>
      </section>

      <section className="pb-14 lg:pb-16">
        <div className="container-wide">
          <span className="text-sm font-semibold uppercase tracking-wider text-primary">{a.plannedEyebrow}</span>
          <h2 className="mt-2 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            {a.plannedTitle}
          </h2>
          <p className="mt-4 max-w-3xl text-base text-muted-foreground">{a.plannedIntro}</p>
          <div className="mt-8 space-y-4">
            {plannedWorkEnvironmentSlugs.map((slug) => {
              const service = workEnvironmentLanding[slug];
              return (
                <CompanyServiceRow
                  key={slug}
                  title={service.title[lang]}
                  intro={service.intro[lang]}
                  price={service.price[lang]}
                  actions={
                    <>
                      <Button asChild variant="hero" size="sm">
                        <a href={companyInquiryHref(lang, slug)}>{copy.shared.sendInquiry}</a>
                      </Button>
                      <Button asChild variant="ghost-outline" size="sm">
                        <a href={companyCertificateHref(slug, lang)}>{copy.shared.requirements}</a>
                      </Button>
                    </>
                  }
                />
              );
            })}
          </div>
          <p className="mt-10 text-sm text-muted-foreground">
            {a.sourcesBefore}{" "}
            <a
              href={workEnvironmentSource}
              className="text-primary underline-offset-2 hover:underline"
              target="_blank"
              rel="noreferrer"
            >
              {a.sourcesLink}
            </a>
            .
          </p>
        </div>
      </section>

      <CompanyContactCTA />
    </CompanyPageShell>
  );
};

export default ForetagArbetsmiljo;
